import React, { useCallback, useEffect, useState } from "react";
import {
  Grid,
  Paper,
  Box,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  Typography,
  CardActionArea,
  Card,
} from "@material-ui/core";
import EmailParserUI from "../../../components/EmailParser/EmailParserUI";
import EmailTableContainer from "../../../components/EmailParser/EmailTableContainer";
import * as calculatorActions from "../Calculator/actions";
import moment from "moment";
import { getOrganizationId, getUserDetails, toastError } from "../../../utils";
import * as actions from "./actions";
import _ from "lodash";
import { BsCheckLg } from "react-icons/bs";
import { LuMailOpen, LuMailX, LuMousePointerClick } from "react-icons/lu";
import EmptyState from "../../../components/Common/EmptyState";
import { BiCopy } from "react-icons/bi";
import { Alert } from "@material-ui/lab";
import { InfoOutlined } from "@material-ui/icons";

const initialAutoFilters = {
  updateSince: { label: "1", value: "1" },
  portRegion: [
    // { label: "Unknown", value: "Unknown" }
  ],
  vesselType: { label: "All", value: "0_99999999" },
  gear: { label: "All", value: "All" },
};

function EmailParser(props) {
  const { loader = false, setLoader = () => { } } = props;

  const [addFleetRegionOptions, setAddFleetRegionOptions] = useState([]);
  const userDetails = getUserDetails();
  const [autoFilters, setAutoFilters] = useState({ ...initialAutoFilters });
  const [emailParserData, setEmailParserData] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState({});
  const [selectedEmailData, setSelectedEmailData] = useState([]);
  const [selectedSingleEmail, setSelectedSingleEmail] = useState({});
  const [savePortListByIndex, setSavePortListByIndex] = useState({});
  const [portLoading, setPortLoading] = useState({});
  const [totalPage, setTotalPage] = useState("");
  const [IsCopied, setIsCopied] = useState(false)
  const [open, setOpen] = useState(false); // State to control modal visibility

  // Function to open the modal
  const handleOpen = () => {
    setOpen(true);
  };

  // Function to close the modal
  const handleClose = () => {
    setOpen(false);
  };

  const [myFilters, setMyFilters] = useState({
    offset: 1,
    limit: 50,
  });

  const delayPortSearch = useCallback(
    _.debounce((index, search) => onSearchPortList(index, search), 500),
    []
  );

  const onSearchPortList = (index, value) => {
    if (value) {
      setPortLoading({ ...portLoading, [index]: true });
      calculatorActions
        .portsByChar(value)
        .then((res) => {
          setPortLoading({ ...portLoading, [index]: false });
          setSavePortListByIndex({
            ...savePortListByIndex,
            [index]:
              (Array.isArray(res.data.list) &&
                res.data.list.map((item) => ({
                  ...item,
                  portLabel: `${item.name} ${item.country ? "(" + item.country + ")" : ""
                    }`,
                }))) ||
              [],
          });
        })
        .catch((err) => {
          setPortLoading({ ...portLoading, [index]: false });
        });
    }
  };

  useEffect(() => {
    calculatorActions.allPortRegions().then((res) => {
      const regionOptions =
        (Array.isArray(res?.data?.list) &&
          res?.data?.list?.map((region) => ({ label: region, value: region }))) ||
        [];
      setAddFleetRegionOptions([
        // { label: "Unknown", value: "Unknown" },
        ...regionOptions,
      ]);
    });
    onSubmitAutoSearch()
  }, []);

  const onChangeNewPortValue = async (index, value, isDate) => {
    let newAddPortsArray = [...emailParserData];
    setLoader(true);
    const data = {
      id: selectedEmailData?._id,
      value: value,
      isDate
    }
    await actions
      .changeMaildetails(data)
      .then((res) => {
        if (isDate) {
          newAddPortsArray[index].nearestDate = { date: value };
        } else {
          newAddPortsArray[index].nearestport = value;
        }
        setEmailParserData(newAddPortsArray);

        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        toastError();
      });
  };
  const onChangePagination = async (type = "") => {

    let newMyFilters = {};
    if (type === "inc") {
      newMyFilters = { ...myFilters, offset: myFilters.offset + 1 };
    } else if (type === "first") {
      newMyFilters = { ...myFilters, offset: 1 };
    } else {
      if (myFilters.offset === 1) return;
      newMyFilters = { ...myFilters, offset: myFilters.offset - 1 };
    }
    await onSubmitAutoSearch(newMyFilters)
    setMyFilters(newMyFilters);
  }
  const onSubmitAutoSearch = (newMyFilters = "") => {
    const { updateSince, portRegion, vesselType, gear } = autoFilters || {};
    const pageFilters = newMyFilters ? newMyFilters : myFilters

    const modifiedFilters = {
      emailDateLower: moment()
        .subtract(Number(updateSince?.value), "d")
        .startOf()
        .format(),
      emailDateUpper: moment().startOf().format(),
      dwtLower: Number(vesselType.value.split("_")[0]),
      dwtUpper: Number(vesselType.value.split("_")[1]),
      portRegion: portRegion.map((item) => item.value).join(","),
      orgId: getOrganizationId(),
      gear: gear.label,
      ...pageFilters
    };

    setLoader(true);

    actions
      .getDataByCumulativeSearch(modifiedFilters)
      .then((res) => {
        if (Array.isArray(res?.data)) setEmailParserData(res?.data);
        setTotalPage(res?.totalPage)
        setSelectedEmailData({})
        setSelectedSingleEmail({})
        setLoader(false);
        setHasFetched(true);
      })
      .catch((err) => {
        setLoader(false);
        setHasFetched(true);
        toastError();
      });
  };

  const onSearchByOrgId = (email) => {
    const { updateSince } = autoFilters || {};
    const searchFilters = {
      emailDateLower: moment()
        .subtract(Number(updateSince.value), "d")
        .startOf()
        .format("yyyy-MM-DD hh:mm"),
      emailDateUpper: moment().startOf().format("yyyy-MM-DD hh:mm"),
      vesselId: email.vesselId || "",
      sender: email?.sender,
      orgId: getOrganizationId(),
    };
    setLoader(true);
    setSelectedEmail(email);
    actions
      .getEmailsByVessel(searchFilters)
      .then((res) => {
        setSelectedEmailData(res);
        setSelectedSingleEmail({})
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        toastError();
      });
  };

  const onChangeAutoVessel = async (mail_id, show, i) => {
    const data = {
      mail_id,
      show
    }

    actions
      .onChangeAutoVessel(data)
      .then((res) => {
        const tmpData = emailParserData
        tmpData[i].showInAutoVessel = show
        setLoader(true);

        setEmailParserData(tmpData)
        setLoader(false);
        // onSearchByOrgId(mail)
        // onSubmitAutoSearch()
      })
      .catch((err) => {
        toastError();
      });
  }

  // const {
  //   sender = "",
  //   subject = "",
  //   deliveredTo = "",
  //   createdDate = "",
  //   emailContent = "",
  // } = selectedSingleEmail;
  const handleCopyEmail = () => {
    navigator.clipboard.writeText(userDetails.forwardEmail)
      .then(() => {
        console.log('Email copied to clipboard');
        setIsCopied(true)
        setTimeout(() => {
          setIsCopied(false)
        }, 2000);
      })
      .catch((err) => {
        console.error('Failed to copy email: ', err);
      });
  };
  return (
    <Grid container alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
      <Grid item xs={12} className="pb-1.5">
        <div className="bg-white border border-[#cbd5e1] p-2">
          <EmailParserUI
            addFleetRegionOptions={addFleetRegionOptions}
            setAutoFilters={setAutoFilters}
            autoFilters={autoFilters}
            onSubmitAutoSearch={onSubmitAutoSearch}
          />
        </div>
      </Grid>

      <Grid item xs={12} className="pb-1.5">
        <EmailTableContainer
          emailParserData={emailParserData}
          onSearchByOrgId={onSearchByOrgId}
          selectedEmail={selectedEmail}
          savePortListByIndex={savePortListByIndex}
          delayPortSearch={delayPortSearch}
          portLoading={portLoading}
          onChangeNewPortValue={onChangeNewPortValue}
          onChangeAutoVessel={onChangeAutoVessel}
          onChangePagination={onChangePagination}
          filters={myFilters}
          totalPage={totalPage}
          hasFetched={hasFetched}
        />
      </Grid>

      <Grid item xs={12} md={8} className="md:pr-1.5 pb-1.5 md:pb-0">
        <TableContainer
          component={Paper}
          className="!rounded-none !shadow-sm mui-selected-grey"
        >
          <Table className="universal-table w-full">
            <TableHead>
              <TableRow>
                <TableCell>Sender</TableCell>
                <TableCell>Subject</TableCell>
                <TableCell>Time</TableCell>
                {/* <TableCell>Add to Auto Vessel</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {loader ? (
                <TableRow>
                  <TableCell colSpan={3} align="center" className="!bg-white">
                    <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                      <CircularProgress />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : selectedEmailData?.mails?.length ? (
                selectedEmailData?.mails?.map((singleEmail, i) => {
                  const {
                    _id,
                    data = "",
                    createdAt = "",
                    showInAutoVessel = false,
                  } = singleEmail;
                  return (
                    <TableRow
                      key={_id}
                      hover
                      className="h-7 cursor-pointer"
                      selected={selectedSingleEmail?.index === i + 1}
                      onClick={() => setSelectedSingleEmail({ ...singleEmail, index: i + 1 })}
                    >
                      <TableCell className="!py-1 !px-2 text-[11px] font-medium border-r border-gray-300">{selectedEmailData?.sender}</TableCell>
                      <TableCell className="!py-1 !px-2 text-[11px] font-medium border-r border-gray-300">{data?.subject}</TableCell>
                      <TableCell className="!py-1 !px-2 text-[11px] font-medium border-r border-gray-300">{moment(createdAt).format("DD MMM YYYY HH:mm:A")}</TableCell>
                      {/* <TableCell onClick={(e) => e.stopPropagation()}>
                        <Switch
                          checked={showInAutoVessel}
                          onChange={(e) => onChangeAutoVessel(selectedEmailData?._id, i, e.target.checked, selectedEmailData)}
                          color="primary"
                        />
                      </TableCell> */}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center" className="!bg-white">
                    <EmptyState
                      icon={selectedEmail?._id ? LuMailX : LuMousePointerClick}
                      title={selectedEmail?._id ? "No emails found" : "No vessel selected"}
                      text={
                        selectedEmail?._id
                          ? "There are no emails for this vessel in the selected period."
                          : "Click a vessel in the positions table above to see its emails here."
                      }
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Grid item xs={12} md={4}>
        <div className="bg-white border border-[#cbd5e1] h-full">
          <div className="bg-[#f8fafc] border-b border-slate-200 text-[11px] text-slate-700">
            <p className="px-2 py-1 m-0 border-b border-slate-200">
              Subject: <span className="text-slate-900">{selectedSingleEmail?.data?.subject}</span>
            </p>
            <p className="px-2 py-1 m-0 border-b border-slate-200">
              From:{" "}
              {selectedSingleEmail?.data?.from?.[0]?.name && (
                <span className="text-slate-900">
                  {selectedSingleEmail?.data?.from?.[0]?.name} &lt;{selectedSingleEmail?.data?.from?.[0]?.address}&gt;
                </span>
              )}
            </p>
            <p className="px-2 py-1 m-0">
              Time Received:{" "}
              <span className="text-slate-900">
                {selectedSingleEmail?.createdAt ? moment(selectedSingleEmail?.createdAt).format("hh:mm:A") : ""}
              </span>
            </p>
          </div>
          <div className="p-2 max-h-[320px] overflow-auto scroll-thin text-[11px] text-slate-900">
            {selectedSingleEmail?.data ? (
              <p className="m-0 whitespace-pre-line">{selectedSingleEmail?.data?.text}</p>
            ) : (
              <EmptyState icon={LuMailOpen} title="No email selected" text="Pick an email from the list to read it here." />
            )}
          </div>
        </div>
      </Grid>
    </Grid >
  );
}

export default EmailParser;
